var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M36 72C55.8823 72 72 55.8823 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6073 45.3929C42.3242 45.6134 41.9642 45.7113 41.6064 45.6652C41.2486 45.619 40.9223 45.4326 40.6991 45.1469L33.9346 36.4673C33.8237 36.3255 33.7415 36.1634 33.6928 35.9904C33.6441 35.8173 33.6297 35.6367 33.6506 35.4588C33.6714 35.2809 33.7271 35.1092 33.8144 34.9535C33.9017 34.7979 34.0189 34.6613 34.1593 34.5515C34.2997 34.4418 34.4606 34.3611 34.6328 34.314C34.805 34.2669 34.9851 34.2544 35.1629 34.2771C35.3406 34.2998 35.5125 34.3573 35.6687 34.4464C35.8249 34.5355 35.9624 34.6543 36.0733 34.7962L42.8378 43.4757C42.9491 43.6178 43.0314 43.7802 43.08 43.9537C43.1287 44.1272 43.1427 44.3082 43.1212 44.4864C43.0998 44.6646 43.0434 44.8365 42.9552 44.992C42.867 45.1476 42.7487 45.2838 42.6073 45.3929Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2263 36.2715L39.941 41.0932",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5727 58.1746C52.3224 58.3674 52.0362 58.5086 51.7304 58.59C51.4246 58.6714 51.1051 58.6915 50.7903 58.6491C50.4755 58.6067 50.1714 58.5026 49.8956 58.3428C49.6197 58.183 49.3774 57.9706 49.1825 57.7177L39.5983 45.2681C39.2056 44.756 39.0305 44.1106 39.1113 43.4738C39.1922 42.8371 39.5225 42.2612 40.0295 41.8728C40.5366 41.4844 41.1789 41.3154 41.8151 41.4029C42.4513 41.4904 43.0293 41.8273 43.422 42.3395L52.9882 54.7911C53.3796 55.3002 53.5556 55.9418 53.4778 56.5758C53.3999 57.2098 53.0745 57.7846 52.5727 58.1746Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9833 10.7147C19.2265 11.6233 16.8088 13.3335 15.0358 15.6291C13.2629 17.9246 12.2144 20.7025 12.0229 23.6114C11.8314 26.5202 12.5055 29.4295 13.96 31.9711C15.4145 34.5128 17.584 36.5728 20.1942 37.8906C22.8045 39.2085 25.7381 39.7249 28.6243 39.3747C31.5105 39.0244 34.2195 37.8232 36.4088 35.923C38.5981 34.0227 40.1694 31.5088 40.9239 28.699C41.6784 25.8893 41.5822 22.9099 40.6476 20.1377C39.3937 16.4207 36.7231 13.34 33.2231 11.5729C29.723 9.80586 25.6801 9.49717 21.9833 10.7147ZM30.6152 36.3222C28.3356 37.0729 25.8783 37.1271 23.5539 36.4779C21.2294 35.8287 19.1423 34.5052 17.5563 32.6748C15.9704 30.8444 14.9569 28.5893 14.6439 26.1947C14.331 23.8 14.7327 21.3734 15.7983 19.2216C16.8639 17.0697 18.5454 15.2894 20.6304 14.1057C22.7153 12.9219 25.1099 12.388 27.5115 12.5713C29.9131 12.7546 32.2137 13.6469 34.1225 15.1355C36.0313 16.6241 37.4626 18.642 38.2353 20.9341C39.2707 24.0082 39.0497 27.3562 37.6207 30.2419C36.1917 33.1276 33.6718 35.3146 30.6152 36.3222Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2363 27.4091C15.8702 26.0204 15.7818 24.5755 15.9761 23.158C16.1705 21.7405 16.6437 20.3786 17.3685 19.1509",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3322 31.5454C17.6317 30.6832 17.0664 29.7196 16.656 28.6885",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8231 35.8425C15.1207 33.6593 13.2895 30.5764 12.6687 27.165C12.0479 23.7536 12.6796 20.2449 14.4468 17.2888C16.214 14.3328 18.997 12.1297 22.2801 11.0877C25.5632 10.0457 29.124 10.2354 32.3029 11.6217",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6175 14.5242C39.0906 16.9256 40.6288 20.1293 40.9515 23.5508C41.2742 26.9724 40.3598 30.3836 38.3751 33.1622C36.3905 35.9408 33.468 37.9015 30.1407 38.6867C26.8134 39.4718 23.3032 39.0291 20.2505 37.4391",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.c9f0ec0dcc8ac9e4d90bbfe905b9c3dd.svg";
export { ForwardRef as ReactComponent };